export const categories = [
  {
    slug: 'shonen',
    name: '少年漫画',
    icon: 'ri-sword-line',
    description: '热血、冒险、成长——少年漫画是JM Comic最受欢迎的分类之一，涵盖战斗、友情、梦想等经典主题，适合所有热爱激情故事的读者。',
    count: 1280,
    color: 'bg-red-100 text-red-700',
    featured: true,
  },
  {
    slug: 'shojo',
    name: '少女漫画',
    icon: 'ri-heart-line',
    description: '细腻的情感描绘、唯美的画风——少女漫画专注于恋爱、校园、奇幻等题材，为读者带来温暖治愈的阅读体验。',
    count: 960,
    color: 'bg-pink-100 text-pink-700',
    featured: true,
  },
  {
    slug: 'doujin',
    name: '同人漫画',
    icon: 'ri-brush-line',
    description: '由爱好者创作的同人作品，基于热门IP的二次创作，展现无限的创意与想象力，是JM Comic最具活力的板块。',
    count: 2450,
    color: 'bg-purple-100 text-purple-700',
    featured: true,
  },
  {
    slug: 'seinen',
    name: '青年漫画',
    icon: 'ri-user-star-line',
    description: '面向成年读者的深度作品，题材广泛涉及社会、科幻、历史、悬疑等，剧情更加成熟复杂。',
    count: 720,
    color: 'bg-blue-100 text-blue-700',
    featured: true,
  },
  {
    slug: 'comedy',
    name: '搞笑漫画',
    icon: 'ri-emotion-laugh-line',
    description: '轻松愉快的搞笑漫画，用幽默的情节和夸张的表现手法，为读者带来欢笑与放松。',
    count: 560,
    color: 'bg-yellow-100 text-yellow-700',
    featured: false,
  },
  {
    slug: 'fantasy',
    name: '奇幻漫画',
    icon: 'ri-magic-line',
    description: '穿越、魔法、异世界——奇幻漫画构建了天马行空的想象世界，满足读者对未知领域的所有幻想。',
    count: 890,
    color: 'bg-green-100 text-green-700',
    featured: false,
  },
  {
    slug: 'mystery',
    name: '悬疑漫画',
    icon: 'ri-search-eye-line',
    description: '推理、侦探、惊悚——悬疑漫画以精巧的剧情设计和出人意料的转折，牢牢抓住读者的好奇心。',
    count: 430,
    color: 'bg-indigo-100 text-indigo-700',
    featured: false,
  },
  {
    slug: 'romance',
    name: '恋爱漫画',
    icon: 'ri-heart-pulse-line',
    description: '甜蜜的恋爱故事，从校园初恋到都市情缘，细腻描绘爱情中的每一个心动瞬间。',
    count: 670,
    color: 'bg-rose-100 text-rose-700',
    featured: false,
  },
];

export const featuredCategories = categories.filter((c) => c.featured);